export default "__VITE_ASSET__CrTO0gE1__"